document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-me-pp-thumb]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-me-pp-gallery]');
  const image = gallery?.querySelector('.me-pp-gallery__main-image');
  if (!image) return;
  image.src = thumb.dataset.src;
  image.alt = thumb.dataset.alt || '';
  gallery.querySelectorAll('[data-me-pp-thumb]').forEach((item) => {
    const active = item === thumb;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-me-pp-variant]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = select.closest('.me-pp-summary')?.querySelector('[data-me-pp-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
});


/* v5.0.1.2 compatibility: keep the premium gallery synchronized with the
   established Moments Etched apparel selector/designer engine. */
window.addEventListener('me:product-media-changed', (event) => {
  const detail = event.detail || {};
  const image = document.querySelector('.me-pp-gallery__main-image');
  if (!image || !detail.frontImage) return;
  image.src = detail.frontImage;
  image.srcset = '';
});

window.addEventListener('me:designer-variant-changed', (event) => {
  const detail = event.detail || {};
  const variantId = detail.variantId;
  if (!variantId) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', String(variantId));
  window.history.replaceState({}, '', url.toString());
});

/* v5.0.1.3: bridge the premium product-page selectors into the full-screen
   designer. The established apparel controller owns the outer selectors;
   the designer mirrors them and proxies interactions back to that source. */
document.addEventListener('DOMContentLoaded', () => {
  const designer = document.querySelector('[data-me-designer]');
  if (!designer) return;

  const allColorSections = Array.from(document.querySelectorAll('[data-me-designer-colors]'));
  const allSizePickers = Array.from(document.querySelectorAll('[data-me-size-picker]'));

  const outerColor = allColorSections.find((node) => !designer.contains(node));
  const innerColor = designer.querySelector('[data-me-designer-colors]');
  const outerSize = allSizePickers.find((node) => !designer.contains(node));
  const innerSize = designer.querySelector('[data-me-size-picker]');

  if (!outerColor || !innerColor || !outerSize || !innerSize) return;

  const getSelectedSize = () => {
    const active = outerSize.querySelector('[data-me-size-button].is-active');
    const property = outerSize.querySelector('[data-me-size-property]');
    return active?.dataset.sizeValue || property?.value || '';
  };

  const getSelectedColor = () => {
    const label = outerColor.querySelector('[data-me-selected-color]');
    return String(label?.textContent || '')
      .replace(/^Selected:\s*/i, '')
      .trim();
  };

  const syncColorControls = () => {
    const outerSwatches = outerColor.querySelector('[data-me-designer-color-swatches]');
    const innerSwatches = innerColor.querySelector('[data-me-designer-color-swatches]');
    if (outerSwatches && innerSwatches) innerSwatches.innerHTML = outerSwatches.innerHTML;

    const color = getSelectedColor();
    const innerLabel = innerColor.querySelector('[data-me-selected-color]');
    const innerStock = innerColor.querySelector('[data-me-selected-color-stock]');
    const outerStock = outerColor.querySelector('[data-me-selected-color-stock]');

    if (innerLabel) innerLabel.textContent = color ? `Selected: ${color}` : 'Select a color';
    if (innerStock && outerStock) {
      innerStock.textContent = outerStock.textContent;
      innerStock.className = outerStock.className;
    }

    innerColor.dataset.meCurrentHandle = outerColor.dataset.meCurrentHandle || '';
    innerColor.dataset.meCurrentColor = color;
  };

  const syncSizeControls = () => {
    const outerGrid = outerSize.querySelector('[data-me-size-grid]');
    const innerGrid = innerSize.querySelector('[data-me-size-grid]');
    const selectedSize = getSelectedSize();

    if (outerGrid && innerGrid) {
      innerGrid.innerHTML = outerGrid.innerHTML;
      innerGrid.hidden = outerGrid.hidden;
    }

    const innerLabel = innerSize.querySelector('[data-me-selected-size]');
    const innerMessage = innerSize.querySelector('[data-me-size-message]');
    const innerProperty = innerSize.querySelector('[data-me-size-property]');

    if (innerLabel) innerLabel.textContent = selectedSize ? `Selected: ${selectedSize}` : 'Size selection required';
    if (innerProperty) innerProperty.value = selectedSize;
    if (innerMessage) {
      innerMessage.textContent = selectedSize ? `Selected size: ${selectedSize}` : 'Select a garment size to continue.';
      innerMessage.classList.toggle('is-required', !selectedSize);
      innerMessage.classList.toggle('is-success', Boolean(selectedSize));
    }
  };

  const syncDesignerControls = () => {
    syncColorControls();
    syncSizeControls();
  };

  /* v15.5.6 — the outer product picker is populated by the legacy color
     engine after this bridge's DOMContentLoaded callback can run. On mobile
     that timing race left the Project Builder copy empty. Observe the outer
     swatch grid and re-sync the inner controls whenever its real buttons are
     created or refreshed. This keeps one commerce color engine/source of truth
     while making the Studio mirror deterministic on every viewport. */
  const outerSwatches = outerColor.querySelector('[data-me-designer-color-swatches]');
  const keepInnerColorAvailable = () => {
    const isStageOne = String(designer.dataset.meStudioStage || '1') === '1';
    if (!isStageOne) return;
    innerColor.hidden = false;
    innerColor.removeAttribute('hidden');
    innerColor.setAttribute('aria-hidden', 'false');
    innerColor.style.removeProperty('display');
  };
  const syncAfterColorEngine = () => {
    keepInnerColorAvailable();
    syncColorControls();
  };

  if (outerSwatches) {
    new MutationObserver(() => window.requestAnimationFrame(syncAfterColorEngine))
      .observe(outerSwatches, { childList: true, subtree: true });
  }

  new MutationObserver(() => {
    if (String(designer.dataset.meStudioStage || '') === '1') {
      window.requestAnimationFrame(syncAfterColorEngine);
    }
  }).observe(designer, { attributes: true, attributeFilter: ['data-me-studio-stage'] });

  [0, 25, 100, 300, 800].forEach((delay) =>
    window.setTimeout(syncAfterColorEngine, delay)
  );

  innerColor.addEventListener('click', (event) => {
    const target = event.target.closest('[data-me-designer-color]');
    if (!target) return;

    const selector = target.dataset.colorHandle
      ? `[data-me-designer-color][data-color-handle="${CSS.escape(target.dataset.colorHandle)}"]`
      : `[data-me-designer-color][data-color-name="${CSS.escape(target.dataset.colorName || '')}"]`;

    const outerTarget = outerColor.querySelector(selector);
    outerTarget?.click();
  });

  innerSize.addEventListener('click', (event) => {
    const target = event.target.closest('[data-me-size-button]');
    if (!target || target.disabled) return;

    const value = target.dataset.sizeValue || '';
    const outerTarget = Array.from(outerSize.querySelectorAll('[data-me-size-button]'))
      .find((button) => button.dataset.sizeValue === value);
    outerTarget?.click();
    window.setTimeout(syncSizeControls, 0);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-me-designer-open]')) syncDesignerControls();
  }, true);

  window.addEventListener('me:variant-selection-state', () => {
    window.setTimeout(syncDesignerControls, 0);
  });

  window.addEventListener('me:designer-color-changed', () => {
    window.setTimeout(syncDesignerControls, 0);
  });

  syncDesignerControls();
});


/* v5.0.2 gallery zoom, quantity handoff, and interaction polish */
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('[data-me-pp-gallery]');
  const dialog = gallery?.querySelector('[data-me-pp-zoom-dialog]');
  const zoomImage = dialog?.querySelector('[data-me-pp-zoom-image]');
  const mainImage = gallery?.querySelector('.me-pp-gallery__main-image');
  gallery?.querySelector('[data-me-pp-zoom-open]')?.addEventListener('click', () => {
    if (zoomImage && mainImage) { zoomImage.src = mainImage.currentSrc || mainImage.src; zoomImage.alt = mainImage.alt || ''; }
    dialog?.showModal();
  });
  gallery?.querySelector('[data-me-pp-zoom-close]')?.addEventListener('click', () => dialog?.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

  const quantity = document.querySelector('[data-me-pp-quantity]');
  const input = quantity?.querySelector('[data-me-pp-quantity-input]');
  const normalize = () => { if (!input) return 1; const value = Math.max(1, Number.parseInt(input.value || '1', 10) || 1); input.value = String(value); return value; };
  quantity?.querySelector('[data-me-pp-quantity-minus]')?.addEventListener('click', () => { input.value = String(Math.max(1, normalize() - 1)); input.dispatchEvent(new Event('change', { bubbles:true })); });
  quantity?.querySelector('[data-me-pp-quantity-plus]')?.addEventListener('click', () => { input.value = String(normalize() + 1); input.dispatchEvent(new Event('change', { bubbles:true })); });
  input?.addEventListener('change', normalize);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-me-designer-open]')) return;
    const designerQuantity = document.querySelector('[data-me-designer] [data-me-quantity-input]');
    if (designerQuantity && input) {
      designerQuantity.value = String(normalize());
      designerQuantity.dispatchEvent(new Event('input', { bubbles:true }));
      designerQuantity.dispatchEvent(new Event('change', { bubbles:true }));
    }
  }, true);
});


/* v5.0.3 production/delivery estimate and group-order messaging */
document.addEventListener('DOMContentLoaded', () => {
  const addBusinessDays = (date, days) => {
    const next = new Date(date);
    let remaining = Math.max(0, Number(days) || 0);
    while (remaining > 0) {
      next.setDate(next.getDate() + 1);
      const weekday = next.getDay();
      if (weekday !== 0 && weekday !== 6) remaining -= 1;
    }
    return next;
  };
  const formatDate = (date) => new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric' }).format(date);

  const timeline = document.querySelector('[data-me-pp-delivery]');
  if (timeline) {
    const now = new Date();
    const productionMin = Number(timeline.dataset.productionMin || 5);
    const productionMax = Math.max(productionMin, Number(timeline.dataset.productionMax || 10));
    const transitMin = Number(timeline.dataset.transitMin || 2);
    const transitMax = Math.max(transitMin, Number(timeline.dataset.transitMax || 5));
    const shipNode = timeline.querySelector('[data-me-pp-ship-window]');
    const deliveryNode = timeline.querySelector('[data-me-pp-delivery-window]');
    const renderTimeline = (quantity = 1) => {
      const additionalProductionDays = Math.floor(Math.max(1, quantity) / 30) * 7;
      const shipMin = addBusinessDays(now, productionMin + additionalProductionDays);
      const shipMax = addBusinessDays(now, productionMax + additionalProductionDays);
      const deliveryMin = addBusinessDays(shipMin, transitMin);
      const deliveryMax = addBusinessDays(shipMax, transitMax);
      if (shipNode) shipNode.textContent = `Estimated to ship ${formatDate(shipMin)}–${formatDate(shipMax)}`;
      if (deliveryNode) {
        const quantityNote = additionalProductionDays ? ` Includes approximately ${additionalProductionDays} additional business days for this quantity.` : '';
        deliveryNode.textContent = `Estimated delivery ${formatDate(deliveryMin)}–${formatDate(deliveryMax)}.${quantityNote} Dates may shift for artwork changes, holidays, or supplier delays.`;
      }
    };
    renderTimeline();
    window.addEventListener('me:quantity-pricing-updated', (event) => renderTimeline(event.detail?.quantity || 1));
  }

  const quantityInput = document.querySelector('[data-me-pp-quantity-input]');
  const savings = document.querySelector('[data-me-pp-group-savings]');
  const message = savings?.querySelector('[data-me-pp-group-message]');
  const bulkLink = savings?.querySelector('[data-me-pp-bulk-link]');
  const updateSavings = () => {
    const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
    if (!message || !bulkLink) return;
    bulkLink.hidden = quantity < 21;
    if (quantity >= 21) message.textContent = '21+ items use custom bulk pricing. Submit a managed quote request for final pricing.';
    else if (quantity >= 11) message.textContent = 'Your estimated group savings tier is 10%.';
    else if (quantity >= 6) message.textContent = 'Your estimated group savings tier is 5%.';
    else message.textContent = 'Save 5% on 6–10 items and 10% on 11–20. Orders of 21+ use custom bulk pricing.';
  };
  quantityInput?.addEventListener('input', updateSavings);
  quantityInput?.addEventListener('change', updateSavings);
  document.querySelector('[data-me-pp-quantity-minus]')?.addEventListener('click', () => setTimeout(updateSavings, 0));
  document.querySelector('[data-me-pp-quantity-plus]')?.addEventListener('click', () => setTimeout(updateSavings, 0));
  updateSavings();
});

/* v5.3.0 Formspark business quote experience */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-me-b2b]').forEach((root) => {
    const dialog = root.querySelector('[data-me-b2b-dialog]');
    const form = dialog?.querySelector('[data-me-b2b-form]');
    if (!dialog || !form) return;

    const valueFrom = (selector, fallback = '') => {
      const node = document.querySelector(selector);
      return String(node?.value || node?.textContent || fallback).replace(/^Selected:\s*/i, '').trim();
    };

    const sync = () => {
      const quantity = valueFrom('[data-me-pp-quantity-input]', '30');
      const color = valueFrom('.me-pp-summary__options [data-me-selected-color]');
      const size = valueFrom('.me-pp-summary__options [data-me-selected-size]');
      const variantId = valueFrom('[data-me-variant-id]');
      const variantSelect = document.querySelector(`[data-me-designer] [data-me-variant-select] option[value="${CSS.escape(variantId)}"]`);
      const fields = {
        '[data-me-b2b-quantity]': quantity,
        '[data-me-b2b-color]': color,
        '[data-me-b2b-size]': size,
        '[data-me-b2b-variant]': variantSelect?.textContent?.trim() || '',
        '[data-me-b2b-variant-id]': variantId,
        '[name="page_url"]': window.location.href,
      };
      Object.entries(fields).forEach(([selector, value]) => {
        const field = dialog.querySelector(selector);
        if (field && value !== '') field.value = String(value);
      });
    };

    const openDialog = () => {
      sync();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };

    root.querySelectorAll('[data-me-b2b-open]').forEach((button) => button.addEventListener('click', openDialog));
    root.querySelector('[data-me-b2b-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });

    const referenceField = form.querySelector('[data-me-b2b-reference]');
    const referenceDisplay = form.querySelector('[data-me-b2b-reference-display]');
    const artworkLink = form.querySelector('[data-me-b2b-artwork-link]');
    const submitButton = form.querySelector('[data-me-b2b-submit]');
    const submitLabel = form.querySelector('[data-me-b2b-submit-label]');
    const success = form.querySelector('[data-me-b2b-success]');
    const errorBox = form.querySelector('[data-me-b2b-errors]');
    const errorMessage = form.querySelector('[data-me-b2b-error-message]');
    const botpoisonPublicKey = String(form.dataset.meBotpoisonPublicKey || '').trim();

    const makeReference = () => {
      const now = new Date();
      const date = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
      const suffix = Math.random().toString(36).slice(2, 8).toUpperCase();
      return `BQ-${date}-${suffix}`;
    };

    const normalizeArtworkLink = () => {
      if (!artworkLink) return;
      const value = artworkLink.value.trim();
      if (!value || /^[a-z][a-z0-9+.-]*:\/\//i.test(value)) return;
      if (/^(www\.|drive\.google\.com|docs\.google\.com|dropbox\.com|onedrive\.live\.com|[^\s]+\.sharepoint\.com|[a-z0-9.-]+\.[a-z]{2,})(\/|$)/i.test(value)) {
        artworkLink.value = `https://${value}`;
      }
    };

    const setSubmitting = (submitting) => {
      if (submitButton) submitButton.disabled = submitting;
      form.setAttribute('aria-busy', submitting ? 'true' : 'false');
      if (submitLabel) submitLabel.textContent = submitting ? 'Sending quote request…' : 'Submit business quote request';
    };

    const formDataToObject = (formData) => {
      const payload = {};
      for (const [key, value] of formData.entries()) {
        if (key === 'website' && value) return null;
        if (key === 'website' || (key === '_honeypot' && !value)) continue;
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          payload[key] = Array.isArray(payload[key]) ? [...payload[key], value] : [payload[key], value];
        } else payload[key] = value;
      }
      payload._email = {
        from: 'Moments Etched Quote Form',
        subject: `New business quote ${payload.quote_reference || ''}`.trim(),
      };
      delete payload['_email.subject'];
      delete payload['_email.from'];
      return payload;
    };

    artworkLink?.addEventListener('blur', normalizeArtworkLink);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      success.hidden = true;
      errorBox.hidden = true;
      sync();
      normalizeArtworkLink();

      if (!form.reportValidity()) return;

      const endpoint = String(form.dataset.meB2bEndpoint || form.action || '').trim();
      if (!/^https:\/\/submit-form\.com\/[A-Za-z0-9_-]+/i.test(endpoint)) {
        errorMessage.textContent = 'The quote service is not configured. Please contact Moments Etched directly.';
        errorBox.hidden = false;
        errorBox.focus?.();
        return;
      }

      const reference = makeReference();
      if (referenceField) referenceField.value = reference;
      const submittedAt = form.querySelector('[name="submitted_at"]');
      if (submittedAt) submittedAt.value = new Date().toISOString();

      const payload = formDataToObject(new FormData(form));
      if (!payload) return;

      setSubmitting(true);
      try {
        if (!window.MomentsBotpoison) throw new Error('Spam protection could not be loaded.');
        payload._botpoison = await window.MomentsBotpoison.challenge(botpoisonPublicKey);

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!response.ok) {
          const responseText = await response.text().catch(() => '');
          const requestError = new Error(responseText || `Formspark returned ${response.status}`);
          requestError.status = response.status;
          throw requestError;
        }

        if (referenceDisplay) referenceDisplay.textContent = `Reference: ${reference}`;
        success.hidden = false;
        form.querySelectorAll('.me-b2b-form__grid, .me-b2b-form__checks, .me-b2b-form__message, .me-b2b-form__submit, .me-b2b-form__privacy')
          .forEach((node) => { node.hidden = true; });
        success.focus?.();
        success.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
        window.dispatchEvent(new CustomEvent('me:business-quote-submitted', { detail: { reference, product: payload.product, quantity: payload.estimated_quantity } }));
      } catch (error) {
        console.error('Business quote submission failed', error);
        errorMessage.textContent = error?.code === 'BOTPOISON_NOT_CONFIGURED'
          ? 'Add the Botpoison public key under Theme settings → Business Quote, then try again.'
          : !navigator.onLine
            ? 'You appear to be offline. Reconnect and try again; your information is still here.'
            : 'The quote service did not accept the request. Please try again in a moment.';
        errorBox.hidden = false;
        errorBox.focus?.();
        errorBox.scrollIntoView?.({ block: 'nearest' });
      } finally {
        setSubmitting(false);
      }
    });
  });
});
